import { useLocation } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SupportPanel } from "@/components/support/support-panel";

/**
 * „Parašyk mums" — /pagalba.
 *
 * The canonical destination, as opposed to the modal: it is linkable, survives a
 * reload, and is somewhere the 404 page can send people. Both mount the same
 * `SupportChat`.
 *
 * Deliberately not called „užklausa" or „support ticket". The app's own habit is
 * to name a thing after what it is to the person reading it — a child gets a
 * „laiškas", not an „ataskaita" — and to a parent at a kitchen table this is
 * writing to somebody, not opening a case.
 */
export default function SupportPage() {
  const location = useLocation();
  // Where they came from, when they arrived by the modal's „atidaryti puslapyje".
  const from = new URLSearchParams(location.search).get("from") || undefined;

  return (
    <div className="mx-auto max-w-2xl p-4 sm:p-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <LifeBuoy className="h-5 w-5 text-primary" />
            Parašyk mums
          </CardTitle>
          <CardDescription>
            Kas nors neveikia, kažko nesupranti arba turi idėją — rašyk čia.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <SupportPanel path={from} />

        </CardContent>
      </Card>
    </div>
  );
}
